import { render, staticRenderFns } from "./VehicleGalleryCard.vue?vue&type=template&id=5c38d1b0"
import script from "./VehicleGalleryCard.vue?vue&type=script&lang=ts"
export * from "./VehicleGalleryCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports